var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9914 18H49.3198C50.579 18 51.5998 19.0208 51.5998 20.28V32.4204C51.5998 37.0483 47.8481 40.8 43.2202 40.8H43.1806C38.5527 40.8006 34.8005 37.0495 34.7998 32.4216V19.1916C34.7998 18.5335 35.3333 18 35.9914 18Z",
    fill: "#1773BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0006 15.5999C47.9829 15.5999 50.4006 13.1823 50.4006 10.1999C50.4006 7.21759 47.9829 4.79993 45.0006 4.79993C42.0182 4.79993 39.6006 7.21759 39.6006 10.1999C39.6006 13.1823 42.0182 15.5999 45.0006 15.5999Z",
    fill: "#1773BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1994 15.6C32.5072 15.6 35.9994 12.1078 35.9994 7.80001C35.9994 3.49218 32.5072 0 28.1994 0C23.8916 0 20.3994 3.49218 20.3994 7.80001C20.3994 12.1078 23.8916 15.6 28.1994 15.6Z",
    fill: "#1773BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6006 18H16.5998C15.3556 18.0308 14.3714 19.0634 14.4002 20.3076V34.1544C14.2265 41.6211 20.1338 47.8173 27.6002 48C35.0667 47.8173 40.974 41.6211 40.8002 34.1544V20.3076C40.8291 19.0634 39.8448 18.0308 38.6006 18Z",
    fill: "#1773BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.8001 18V37.404C28.7941 38.2938 28.2549 39.0932 27.4321 39.432C27.1701 39.5428 26.8885 39.5999 26.6041 39.6H15.456C15.3001 39.204 15.1561 38.808 15.036 38.4C14.616 37.0231 14.4017 35.5916 14.4 34.152V20.304C14.3712 19.0617 15.3538 18.0308 16.596 18H28.8001Z",
    fill: "#1773BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.6001 18V38.604C27.6 38.8885 27.5429 39.17 27.4321 39.432C27.0933 40.2548 26.2939 40.794 25.4041 40.8H16.0201C15.816 40.404 15.6241 40.008 15.456 39.6C15.288 39.192 15.1561 38.808 15.036 38.4C14.616 37.0231 14.4017 35.5916 14.4 34.152V20.304C14.3712 19.0617 15.3538 18.0308 16.596 18H27.6001Z",
    fill: "#1773BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.6 18V36.204C27.5909 37.413 26.6131 38.3909 25.404 38.4H15.036C14.616 37.0231 14.4017 35.5916 14.4 34.152V20.304C14.3712 19.0617 15.3538 18.0308 16.596 18H27.6Z",
    fill: "#1773BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.4 18V36.204C26.3909 37.413 25.413 38.3909 24.204 38.4H15.036C14.616 37.0231 14.4017 35.5916 14.4 34.152V20.304C14.3712 19.0617 15.3538 18.0308 16.596 18H26.4Z",
    fill: "#1773BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.8002 11.796V15.576C28.5962 15.5879 28.4042 15.6 28.2002 15.6C27.9962 15.6 27.8042 15.588 27.6002 15.576C27.1952 15.5491 26.7934 15.4848 26.4002 15.384C23.9702 14.8085 21.9626 13.1043 21.0002 10.8C20.8346 10.413 20.7061 10.0112 20.6162 9.59998H26.6042C27.8151 9.60456 28.7956 10.585 28.8002 11.796Z",
    fill: "#1773BC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.601 12.996V15.576C27.1959 15.5492 26.7942 15.4849 26.401 15.384C23.971 14.8086 21.9634 13.1044 21.001 10.8H25.405C26.6159 10.8046 27.5964 11.7851 27.601 12.996Z",
    fill: "#1773BC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.601 12.996V15.576C27.1959 15.5492 26.7942 15.4849 26.401 15.384C23.971 14.8086 21.9634 13.1044 21.001 10.8H25.405C26.6159 10.8046 27.5964 11.7851 27.601 12.996Z",
    fill: "#1773BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.401 12.996V15.384C23.971 14.8086 21.9634 13.1044 21.001 10.8H24.205C25.4159 10.8047 26.3964 11.7852 26.401 12.996Z",
    fill: "#1773BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19959 10.8H24.2004C25.4152 10.8 26.4 11.7849 26.4 12.9996V35.0004C26.4 36.2152 25.4152 37.2 24.2004 37.2H2.19959C0.984779 37.2 0 36.2152 0 35.0004V12.9996C0 11.7849 0.984803 10.8 2.19959 10.8Z",
    fill: "#1773BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9887 19.1737H14.5907V31.1497H11.7887V19.1737H7.41113V16.8505H18.9887V19.1737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.033c0f45bb084a4eb61b6ae3c701e06f.svg";
export { ForwardRef as ReactComponent };